import mrpStyles from './../mrpRtl.json'

const title = {
  fontSizeMobile: '24px',
  lineHeightMobile: '30px',
  fontWeight: '400',
  textTransform: 'uppercase',
  fontSizeDesktop: '28px',
  lineHeightDesktop: '35px',
  color: mrpStyles.colors.PrimaryBlack
}

const cta = {
  fontWeight: '400',
  lineHeight: '25px',
  letterSpacing: '0.21px',
  color: mrpStyles.colors.PrimaryBlack
}

const paragraph = {
  fontWeight: '400',
  fontSize: '22px',
  lineHeight: '33px',
  color: mrpStyles.colors.PrimaryBlack
}

const loyaltyBanner = {
  title,
  cta,
  paragraph
}

export default loyaltyBanner
